/**
 * Response Text Service
 * Centralized mapping of form response texts
 */

export const FORM_RESPONSE_TEXTS = {
  GENERAL: 'INTEGRATIONS.COPILOT.FORM.GENERAL',
  CONNECTION: 'INTEGRATIONS.COPILOT.FORM.CONNECTION',
  CREATE_ACCOUNT: 'INTEGRATIONS.COPILOT.FORM.CREATE_ACCOUNT',
  UPDATE_ACCOUNT: 'INTEGRATIONS.COPILOT.FORM.UPDATE_ACCOUNT',
  ENABLE_ACCOUNT: 'INTEGRATIONS.COPILOT.FORM.ENABLE_ACCOUNT',
  DISABLE_ACCOUNT: 'INTEGRATIONS.COPILOT.FORM.DISABLE_ACCOUNT',
  REMOVE_ACCOUNT: 'INTEGRATIONS.COPILOT.FORM.REMOVE_ACCOUNT',
  CREATE_ACCOUNT_EDIT: 'INTEGRATIONS.COPILOT.FORM.CREATE_ACCOUNT_EDIT',
  UPDATE_ACCOUNT_EDIT: 'INTEGRATIONS.COPILOT.FORM.UPDATE_ACCOUNT_EDIT',
  ENABLE_ACCOUNT_EDIT: 'INTEGRATIONS.COPILOT.FORM.ENABLE_ACCOUNT_EDIT',
  DISABLE_ACCOUNT_EDIT: 'INTEGRATIONS.COPILOT.FORM.DISABLE_ACCOUNT_EDIT',
  REMOVE_ACCOUNT_EDIT: 'INTEGRATIONS.COPILOT.FORM.REMOVE_ACCOUNT_EDIT',
} as const;

export type FormResponseTextKey = keyof typeof FORM_RESPONSE_TEXTS;
